const openCloseEditGroupSet = (state, action) => ({
  ...state,
  editGroupSetDialogOpenFor: action.payload.editGroupSetDialogOpenFor,
});

export default openCloseEditGroupSet;
